import { spacing as brandSpacing } from '../brand2020/spacing';
import { Spacing } from '../types';

export const spacing: Spacing = {
  ...brandSpacing,
};
